import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Card, Typography, Divider } from "antd";
import {
  SYS_CODE,
  SYS_NAME,
  CLIENT_URL,
  SYS_MANUAL_URL,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import "./home.less";

import SearchBulletinboard from "../../pages/bulletinBoard/search-bulletinboard";
import RegisterReservation from "../../pages/awardsreservation/register-reservation";
import SurveyStudent from "../../pages/accommodation/survey-student";
import AlumniModifyStatistics from "../decisionsupport/alumni-modify-statistics-list";
import MyParticipantRegisterList from "../../pages/contestsignup/my-participant-register-list";
import VoterChoiceWorksList from "../../pages/contestsignup/voter-choice-works-list";
import AlertMessageList from "../teachingquailty/alert-message-list";
// import AlumniApplyUpdate from "../../pages/alumni/alumni-apply-update";
import SignerEnrolmentSelf from "../../pages/gatesecurity/signer-enrolment-self";
import StudentApplyScholarships from "../../pages/alumnischolarships/student-apply-scholarships";
import CreateCourseSelection from "../../pages/aiprompt/create-course-selection";
import ClockLogSelf from "../../pages/punchinout/clock-log-self";
import OneDaySelf from "../punchinout/one-day-self";
import CourseStudentEveryweekLog from "../../pages/distancelearning/course-student-everyweek-log";
import RemoteLearningCourse from "../../pages/distancelearning/remote-learning-course";

const { Title, Link, Text, Paragraph } = Typography;

class Home extends Component {
  state = {
    deviceWidth: 0,
    surveyfirstyear: "113",
    surveythreeyear: "111",
    surveyfiveyear: "109",
  };

  //   componentDidMount() {
  //     window.addEventListener("resize", this.resize.bind(this));
  //     this.resize();
  //   }

  //   resize() {
  //     this.setState({ deviceWidth: window.innerWidth });
  //   }

  render() {
    const { surveyfirstyear, surveythreeyear, surveyfiveyear } = this.state;
    const user = this.props.user;
    //console.log("user:", user);
    const { role } = this.props.user;
    const userLevel = usrRole(role);
    var html = "";
    switch (SYS_CODE) {
      case "RTS":
        html =
          userLevel === "EXECUTIVE" ? ( //高階管理者
            <RemoteLearningCourse />
          ) : userLevel === "WORK" ? ( //一般管理者
            <RemoteLearningCourse />
          ) : userLevel === "TEACHER" ? (
              <CourseStudentEveryweekLog />
          ) : userLevel === "STUDENT" ? (
            <div className="home">歡迎使用{SYS_NAME}</div>
          ) : (
            <div className="home">歡迎使用{SYS_NAME}</div>
          );
        break;
      case "PIM":
        html =
          userLevel === "STAFF" ? (
            <OneDaySelf />
          ) : userLevel === "UNITC" ? (
            <OneDaySelf />
          ) : userLevel === "UNITB" ? (
            <OneDaySelf />
          ) : userLevel === "POFFICEA" ? (
            <OneDaySelf />
          ) : userLevel === "POFFICEB" ? (
            <OneDaySelf />
          ) : (
            <div className="home">歡迎使用{SYS_NAME}</div>
          );

        break;
      case "AFS":
        html =
          userLevel === "STUDENT" ? (
            <StudentApplyScholarships />
          ) : (
            <div className="home">歡迎使用{SYS_NAME}</div>
          );
        break;
      case "SSP":
        html = (
          <div className="home">
            歡迎使用{SYS_NAME}
            {SYS_CODE === "SSP" ? (
              <>
                {" "}
                <a
                  className="btn btn-outline-primary btn-sm"
                  href={SYS_MANUAL_URL}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i
                    className="fa fa-question-circle"
                    style={{ marginRight: "5px" }}
                  ></i>
                  操作手冊
                </a>
              </>
            ) : (
              <></>
            )}
            {SYS_CODE === "SMS" ? (
              <>
                {" "}
                <a
                  className="btn btn-outline-primary btn-sm"
                  href={SYS_MANUAL_URL}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i
                    className="fa fa-question-circle"
                    style={{ marginRight: "5px" }}
                  ></i>
                  操作手冊
                </a>
              </>
            ) : (
              <></>
            )}
          </div>
        );
        break;
      case "SIM":
        html =
          userLevel === "STAFF" ? (
            <ClockLogSelf />
          ) : (
            <div className="home">歡迎使用{SYS_NAME}</div>
          );
        break;
      case "GSM":
        html =
          userLevel === "SIGNER" ? (
            <SignerEnrolmentSelf />
          ) : (
            <div className="home">歡迎使用{SYS_NAME}</div>
          );
        break;
      case "TQA":
        html = (
          <>
            <SearchBulletinboard />
            <AlertMessageList />
          </>
        );
        break;
      case "ARS":
        html =
          userLevel === "GRADUATE" ? (
            <RegisterReservation />
          ) : (
            <div className="home">歡迎使用{SYS_NAME}</div>
          );
        break;
      case "SLM":
        html =
          userLevel === "STUDENT" ? <SurveyStudent /> : <SearchBulletinboard />;
        break;
      case "GQM":
        html =
          userLevel === "ALUMNI" ? (
            <Card>
              <Typography>
                <Title>親愛的畢業校友，您好</Title>
                <Paragraph>
                  已畢業的您現況如何？母校十分關心您，希望瞭解您的現況與感想。本項調查結果將提供母校辦學及校務發展改善、系所學位學程課程規劃及高等教育人才培育相關政策研議之參考。
                </Paragraph>
                <Paragraph>
                  您的意見十分重要，懇請耐心協助填答。本調查不會影響您任何權益，但請勿轉由他人代為填答。母校由衷希望您能撥冗回覆本調查。
                  本問卷結果將依個人資料保護法規定嚴密保管與遵循法令規定處理，並提供以下單位進行後續運用，以及避免重複向您蒐集資料，敬請放心填答。
                </Paragraph>
                <Paragraph>
                  <ul>
                    <li>
                      <Text>提供教育部進行教育政策研議與分析…等事項。</Text>
                    </li>
                    <li>
                      <Text>
                        提供學校辦理教學改進、服務追蹤、資訊交流及未來校友服務…等事項。
                      </Text>
                    </li>
                  </ul>
                </Paragraph>
                <Paragraph>
                  如對本問卷填答有任何疑問或需依個人資料保護法第3條規定行使相關權利時，歡迎以E-Mail或電話與我們聯絡。感謝您的填答！
                </Paragraph>
                <Paragraph>
                  <ul>
                    <li>
                      <Text>
                        承辦單位：
                        <Link href="https://cds-rd.tut.edu.tw/">
                          研究暨國際發展處 - 職涯發展中心
                        </Link>
                      </Text>
                    </li>                    
                    <li>
                      <Text>
                        聯絡電話：<Link href="TEL:06-2421971">06-2421971</Link>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        E-Mail：
                        <Link href="mailto:emtalk@mail.tut.edu.tw">
                          emtalk@mail.tut.edu.tw
                        </Link>
                      </Text>
                    </li>
                    <li>
                      <Divider
                        orientation="left"
                        style={{
                          borderColor: "#7cb305",
                        }}
                      >
                        <i className="fa fa-graduation-cap"></i> 畢業滿1年(
                        {surveyfirstyear}學年度畢業生)
                      </Divider>
                      <a
                        style={{ margin: "3px", display: "inline-block" }}
                        href={CLIENT_URL + "/alumnisurvey/surveyfirstyear"}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-outline-primary"
                      >
                        滿1年學生流向追蹤問卷調查請按此{" "}
                        <i className="fa fa-hand-pointer"></i>
                      </a>
                    </li>
                    <li>
                      <Divider
                        orientation="left"
                        style={{
                          borderColor: "#7cb305",
                        }}
                      >
                        <i className="fa fa-graduation-cap"></i> 畢業滿3年(
                        {surveythreeyear}學年度畢業生)
                      </Divider>
                      <a
                        style={{ margin: "3px", display: "inline-block" }}
                        href={CLIENT_URL + "/alumnisurvey/surveythreeyear"}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-outline-primary"
                      >
                        滿3年學生流向追蹤問卷調查請按此{" "}
                        <i className="fa fa-hand-pointer"></i>
                      </a>
                    </li>
                    <li>
                      <Divider
                        orientation="left"
                        style={{
                          borderColor: "#7cb305",
                        }}
                      >
                        <i className="fa fa-graduation-cap"></i> 畢業滿5年(
                        {surveyfiveyear}學年度畢業生)
                      </Divider>
                      <a
                        style={{ margin: "3px", display: "inline-block" }}
                        href={CLIENT_URL + "/alumnisurvey/surveyfiveyear"}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-outline-primary"
                      >
                        滿5年學生流向追蹤問卷調查請按此{" "}
                        <i className="fa fa-hand-pointer"></i>
                      </a>
                    </li>
                  </ul>
                </Paragraph>
              </Typography>
            </Card>
          ) : (
            <div>
              <SearchBulletinboard />
            </div>
          );
        break;
      case "AMS":
        html =
          userLevel === "ALUMNI" ? (
            <div className="home">
              <a
                href={CLIENT_URL + "/alumni/cardapply"}
                target="_blank"
                rel="noreferrer"
                className="btn btn-success"
              >
                <i className="fa fa-address-card"></i> 學思卡申請
              </a>

              <a
                style={{ margin: "3px", display: "inline-block" }}
                href={CLIENT_URL + "/alumni/alumniapplyUpdate"}
                target="_blank"
                rel="noreferrer"
                className="btn btn-success"
              >
                個資變更申請 <i className="fa fa-user-circle"></i>
              </a>
            </div>
          ) : (
            <div className="home">歡迎使用{SYS_NAME}</div>
          );
        break;
      case "ECA":
        html = <div className="home">歡迎使用{SYS_NAME}</div>;
        break;
      case "ILA":
        html = <div className="home">歡迎使用{SYS_NAME}</div>;
        break;
      case "EPS":
        html = (
          <div className="home">
            <span>歡迎使用{SYS_NAME}</span>
            <div style={{ marginRight: "3px" }}>
              <a
                href={CLIENT_URL + "/blog"}
                target="_blank"
                rel="noreferrer"
                className="btn btn-sm btn-success"
              >
                <i className="fas fa-location-arrow"></i> 公眾頁
              </a>
            </div>
          </div>
        );
        break;
      case "DSS":
        html =
          userLevel === "PRESIDENT" ? (
            <>
              <AlumniModifyStatistics />
            </>
          ) : (
            <AlumniModifyStatistics />
          );
        break;
      case "CSLC":
        html =
          userLevel === "PARTICIPANT" ? (
            <MyParticipantRegisterList />
          ) : (
            <div className="home">歡迎使用{SYS_NAME}</div>
          );
        break;
      case "CSLL":
        html =
          userLevel === "VOTER" ? (
            <VoterChoiceWorksList />
          ) : (
            <div className="home">歡迎使用{SYS_NAME}</div>
          );
        break;
      // AI 相關系統
      case "APS":
        html = <div className="home">歡迎使用{SYS_NAME}</div>;
        break;
      case "I01":
        html = <CreateCourseSelection />;
        break;
      default:
        html = <div className="home">歡迎使用{SYS_NAME}</div>;
        break;
    }

    if (!user || !user.token) {
      return <Redirect to="/login" />;
    } else {
      return html;
    }
  }
}

export default connect((state) => ({ user: state.user }), {})(Home);
